// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const coverTableStyle = theme => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},

	margin: {
		padding:5,
		// margin: 0,
		minHeight: 0,
		minWidth: 0,
	}
})


export default coverTableStyle